import { action } from 'easy-peasy';
import { UrlStateStore } from '../types';

export const urlStateStore: UrlStateStore = {
  persistedState: {},
  setPersistedState: action((state, payload) => {
    state.persistedState = payload;
  }),
  updatePersistedState: action((state, payload) => {
    state.persistedState = { ...state.persistedState, ...payload };
  }),
  resetPersistedState: action(state => {
    state.persistedState = {};
  }),
};
